import React, { Component, Fragment } from 'react'
import { injectIntl, FormattedMessage, FormattedDate, FormattedTime, FormattedNumber } from 'react-intl'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { createBooking } from '../actions/bookingActions'
import { isWeekday, useDailyInsurance, getProductFrom, skuPrice, skuIdPrice } from '../lib/utils'
// Eslint disbling by V: Temp, as decontruction of BookingLib is not everywhere yet
// eslint-disable-next-line import/no-duplicates
import BookingLib, { isWeekdayEqualToWeekendPrice, insuranceMandatoryPrice, insuranceCancellationPrice, insuranceRentalPrice, replacementCardPrice, couponValue } from '../lib/booking'
// eslint-disable-next-line import/no-duplicates
import { hourPriceOnDay, calculateHoursCount, isEligibleForVolumeDiscount, volumeDiscount, isCustomVoucherAndInvalid } from '../lib/booking'

class BookingCart extends Component {

  constructor(props) {
    super(props)
    this.state = {
      booking: props.booking
    }
    this.keyCount = 0
    this.getKey   = this.getKey.bind(this)
  }

  getKey() {
    this.keyCount += 1
    return this.keyCount
  }

  productLine(person) {

    const passType = person.passType
      || (person.membership && person.membership.type)

    return (
      !passType 
      ? null
      : (
        <Fragment key={this.getKey()}>
          <tr>
            <td colSpan={4} className="pt-3">
              <h3 className="mb-0">
                {`${person.firstName || ''} ${person.lastName || ''}`}
              </h3>
            </td>
          </tr>
          {this.passRow(person)}
          {this.insuranceRow(person)}
          {person.replacementCard && (
            this.replacementCardRow(person)
          )}
          {person.rental && (
            this.rentalRow(person)
          )}
          {person.instruction && person.instruction.skuName && (
            this.instructionRow(person)
          )}

          {person.appliedVoucher && (
            this.voucherRow(person)
          )}

          {person.couponInfo && (
            this.couponRow(person)
          )}
        </Fragment>
      )
    )
  }

  passRow(person) {
    const passType = person.passType
                      || (person.membership && person.membership.type)
    const product = getProductFrom(passType)
    const { booking } = this.state
    const { skus, overrideHours } = this.props
    const hoursCount = calculateHoursCount(booking.whenStartTime, booking.whenEndTime)

    // Claculate days which are considered special weekeends from override hours array
    const specialWeekends = overrideHours.filter(d => d.isWeekend)
    const showWeekendRate = !isWeekday(new Date(booking.whenStartTime), specialWeekends)
      && !isWeekdayEqualToWeekendPrice(product, skus)
    
    return (
      <>
        <tr className="text-sm" key={this.getKey()}>
          <td>
            <FormattedMessage
              id={`booking.cart.${product.id}`}
              defaultMessage={product.defaultName}
            />
            { showWeekendRate && (
              <FormattedMessage
                id="booking.cart.weekendRate"
                defaultMessage=", (Rate: weekend/holiday)"
              />
            )}
          </td>
          <td className="text-right">
            <FormattedNumber
              minimumFractionDigits={2}
              value={((!person.membership
                || (person.membership && person.passType && person.membership.type !== person.passType)
              ) && skuPrice(product, null, skus) || 0)}
            />
            &nbsp;DKK.
          </td>
          <td className="text-right">
            <FormattedNumber
              minimumFractionDigits={2}
              value={hourPriceOnDay(product, booking, skus, specialWeekends)}
            />
            &nbsp;DKK. x&nbsp;
            {hoursCount}
            t
          </td>
          <td className="text-right">
            <FormattedNumber
              minimumFractionDigits={2}
              value={BookingLib.totalPassPrice(person, product, booking, skus, overrideHours)}
            />
            &nbsp;DKK.
          </td>
        </tr>
        {this.volumeDiscountRow(passType, hoursCount, person)}
      </>
    )
  }

  volumeDiscountRow(passType, hoursCount, person) {
    const ageCategory = person.ageCategory || person.membership && person.membership.ageCategory
    if (!isEligibleForVolumeDiscount(passType, hoursCount)) {
      return <></>
    }
    return (
      <tr className="text-sm" key={this.getKey()}>
        <td colSpan="3">
          <FormattedMessage id="booking.cart.volumeDiscount" defaultMessage="3 hour discount" />
          ,&nbsp;
          <FormattedMessage id={`booking.cart.${ageCategory}`} />
        </td>
        <td className="text-right">
          <FormattedNumber
            minimumFractionDigits={2}
            value={volumeDiscount(ageCategory)}
          />
          &nbsp;DKK.
        </td>
      </tr>
    )
  }

  insuranceRow(person) {
    const { props } = this
    const {skus, intl} = props
    const termsUrl = intl.formatMessage({ id: 'booking.insurance.linkUrl'})

    return (
      <>
        {/* {(!person.membership
          || (person.membership 
              && useDailyInsurance(person.membership.type)
          ) 
        ) && (
          <tr className="text-sm">
            <td colSpan={3}>
              {useDailyInsurance(person.passType || person.membership.type)
                ? <FormattedMessage id="booking.cart.insuranceDailyMandatory" defaultMessage="Mandatory daily insurance" />
                : <FormattedMessage id="booking.cart.insuranceYearlyMandatory" defaultMessage="Mandatory yearly insurance" />
              }
              &nbsp;-&nbsp;
              <button
                type="button"
                onClick={() => props.openTermsModal(termsUrl)}
                className="font-bold underline"
              >
                <FormattedMessage id="booking.insurance.linkText" />
              </button>
            </td>
            <td className="text-right">
              <FormattedNumber
                minimumFractionDigits={2}
                value={insuranceMandatoryPrice(person, skus)}
              />
              &nbsp;DKK.
            </td>
          </tr>
        )} */}
        
        {person.insuranceCancellation && (
          <tr className="text-sm">
            <td colSpan={3}>
              <FormattedMessage
                id="booking.cart.insuranceCancellation"
                defaultMessage="Cancellation insurance"
              />
            </td>
            <td className="text-right">
              <FormattedNumber
                minimumFractionDigits={2}
                value={insuranceCancellationPrice(person, skus)}
              />
              &nbsp;DKK.
            </td>
          </tr>          
        )}
        {person.rental && person.rental.insurance && (
          <tr className="text-sm">
            <td colSpan={3}>
              <FormattedMessage
                id="booking.cart.insuranceRental"
                defaultMessage="Rental insurance"
              />
            </td>
            <td className="text-right">
              <FormattedNumber
                minimumFractionDigits={2}
                value={insuranceRentalPrice(person, skus)}
              />
              &nbsp;DKK.
            </td>
          </tr>          
        )}
      </>
    )
  }

  replacementCardRow(person) {
    const { props } = this
    const { skus } = props

    return (
      <tr className="text-sm">
        <td colSpan={3}>
          <FormattedMessage
            id="booking.cart.replacementCard"
            defaultMessage="Replacement card"
          />
        </td>
        <td className="text-right">
          <FormattedNumber
            minimumFractionDigits={2}
            value={replacementCardPrice(person, skus)}
          />
          &nbsp;DKK.
        </td>
      </tr>
    )
  }

  rentalRow(person) {
    const { skus } = this.props

    const lineTemplate = (type) => person.rental.equipment[type] && (
      <tr className="text-sm" key={this.getKey()}>
        <td>
          <FormattedMessage id={`booking.person.rental.${type}`} />
        </td>
        <td />
        <td />
        <td className="text-right">
          <FormattedNumber
            minimumFractionDigits={2}
            value={skuIdPrice(person.rental.equipment[type], skus)}
          />
          &nbsp;DKK
        </td>
      </tr>
    )

    return person.rental && person.rental.equipment
      ? Object.keys(person.rental.equipment).map(type => lineTemplate(type))
      : []
  }

  instructionRow(person) {
    const { skus } = this.props
    const { skuId, skuName } = person.instruction
    return (
      <tr className="text-sm">
        <td colSpan="2">
          <FormattedMessage
            id={`booking.cart.instruction.${skuName}`}
            default="Instruction"
          />
        </td>
        <td />
        <td className="text-right">
          <FormattedNumber
            minimumFractionDigits={2}
            value={skuIdPrice(skuId, skus)}
          />
          &nbsp;DKK.
        </td>
      </tr>
    )    
  }

  voucherRow(person) {
    const { booking } = this.state
    const { skus, overrideHours, email } = this.props
    const invalid = isCustomVoucherAndInvalid(person.voucher, email)

    return (
      <tr className="text-sm">
        <td colSpan={3}>
          <span style={{ textDecoration: (invalid ? 'line-through' : 'initial') }}>
            Voucher
          </span>
          {invalid && (
            <>&nbsp; restricted</>
          )}
          {/* {person.appliedVoucher && !person.appliedVoucher.amount && (
            <>
              &nbsp;-&nbsp;
              <span className="text-sky font-bold">
                {['passHourlyAdult', 'passHourlyChild'].includes(person.passType)
                  ? '2 gratis ski'
                  : `20% rabat på skikort`
                }
              </span>
            </>
          )} */}
        </td>
        <td className="text-right">
          <FormattedNumber
            minimumFractionDigits={2}
            value={BookingLib.voucherValue(person, booking, skus, overrideHours, email)}
          />
          &nbsp;DKK.
        </td>
      </tr>
    )
  }

  couponRow(person) {
    const { booking } = this.state
    const { skus, overrideHours } = this.props

    return (
      <tr className="text-sm">
        <td colSpan={3}>
          Rabatkupon
          {person.couponInfo && person.couponInfo.percent_off && (
            <span className="text-sky font-bold pl-2">
              {`-${person.couponInfo.percent_off}%`}
            </span>
          )}
        </td>
        <td className="text-right">
          <FormattedNumber
            minimumFractionDigits={2}
            value={couponValue(person, booking, skus, overrideHours)}
          />
          &nbsp;DKK.
        </td>
      </tr>
    )
  }

  render() {
    const { booking, currentModal } = this.state
    const { skus, overrideHours, email } = this.props
  
    return (
      <>
        { currentModal }

        <div className="mt-4">
          <div className="flex flex-wrap bg-harbor p-2 md:p-0">
            <h2 className="flex-grow text-aluminium m-0 p-0 md:p-6 w-full md:w-auto">
              <FormattedMessage
                id="booking.cart.header"
                defaultMessage="Your booking"
              />
            </h2>
            <div className="flex flex-col justify-center text-aluminium text-sm mr-12">
              <div className="font-bold text-sky">
                <FormattedMessage
                  id="booking.cart.date"
                  defaultMessage="Date"
                />
              </div>
              <FormattedDate
                value={booking.whenStartTime}
                year='numeric'
                month='long'
                day='numeric'
              />  
            </div>
            <div className="flex flex-col justify-center text-aluminium text-sm mr-16">
              <div className="font-bold text-sky">
                <FormattedMessage
                  id="booking.cart.time"
                  defaultMessage="Ski time"
                />
              </div>
              <span className="whitespace-no-wrap">
                <FormattedTime value={booking.whenStartTime} />
                &nbsp;-&nbsp;
                <FormattedTime value={booking.whenEndTime} />
              </span>
            </div>
          </div>
          <div className="bg-aluminium p-2 md:px-8 md:py-6">
            <table className="w-full border-collapse">
              <thead>
                <tr className="text-sm">
                  <th className="text-left pb-3 border-b border-grey">
                    <FormattedMessage
                      id="booking.cart.item"
                      defaultMessage="Item"
                    />
                  </th>
                  <th className="text-right pb-3 border-b border-grey">
                    <FormattedMessage
                      id="booking.cart.membership"
                      defaultMessage="Membership"
                    />
                  </th>
                  <th className="text-right pb-3 border-b border-grey">
                    <FormattedMessage
                      id="booking.cart.hourRate"
                      defaultMessage="Hour Rate"
                    />
                  </th>
                  <th className="text-right pb-3 border-b border-grey">
                    <FormattedMessage
                      id="booking.cart.subTotal"
                      defaultMessage="Subtotal"
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                {booking.people 
                  ? booking.people.map((person, index) => this.productLine(person, index))
                  : null
                }
              </tbody>
            </table>
          </div>
          <div className="flex bg-aluminium">
            <div className="rounded-full h-6 w-6 -ml-3 bg-white" />
            <div className="flex-grow bg-dotted-line h-6" />
            <div className="rounded-full h-6 w-6 -mr-3 bg-white" />
          </div>
          <div className="bg-aluminium px-8 py-6">
            <div className="flex items-baseline">
              <div className="flex-grow text-xl font-bold">
                <FormattedMessage
                  id="booking.cart.grandTotal"
                  defaultMessage="Grand total"
                />
              </div>
              <div className="text-2xl font-bold">
                <FormattedNumber
                  minimumFractionDigits={2}
                  value={BookingLib.totalBookingSum(booking, skus, overrideHours, email)} 
                />
                &nbsp;DKK.
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

BookingCart.propTypes = {
  booking: PropTypes.shape({
    booking: PropTypes.object
  }).isRequired,
  skus: PropTypes.instanceOf(Array).isRequired,
  overrideHours: PropTypes.instanceOf(Array).isRequired,
  email: PropTypes.string
}

BookingCart.defaultProps = {
  email: ''
}

const mapStateToProps = state => ({
  booking: state.booking
})

export default connect(mapStateToProps, { createBooking })(injectIntl(BookingCart))